module.exports = __webpack_public_path__ + "favicon.f7b54f13ab072374f5dce8f8e2eff1f9.png";